import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'log',
	standalone: true
})
export class LogPipe implements PipeTransform {
	transform(value: any, args?: any): any {
		console.log(value, args);
		return value;
	}
}
